import { EditRendererComponent } from './edit-renderer/edit-renderer.component';
import { DeleteRendererComponent } from './delete-renderer/delete-renderer.component';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';
import { CheckboxRendererComponent } from './checkbox-renderer/checkbox-renderer.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatMomentDateModule, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { QuillModule } from 'ngx-quill';
import { TranslocoModule } from '@ngneat/transloco';
import { AgGridModule } from 'ag-grid-angular';
import { ControlGenericComponent } from './generic-design/control-generic/control-generic.component';
import { TextComponent } from './generic-design/atoms/text/text.component';
import { DateComponent } from './generic-design/atoms/date/date.component';
import { NumberComponent } from './generic-design/atoms/number/number.component';
import { LocationPickerComponent } from './generic-design/atoms/location-picker/location-picker.component';
import { ImagePickerComponent } from './generic-design/atoms/image-picker/image-picker.component';
import { AgmCoreModule } from '@agm/core';
import { DropDownEntityComponent } from './generic-design/atoms/drop-down-entity/drop-down-entity.component';
import { LocalizedPipe } from './localized.pipe';
import { CheckboxComponent } from './generic-design/atoms/checkbox/checkbox.component';
import { IconRendererComponent } from './icon-renderer/icon-renderer.component';
import { DropDownComponent } from './generic-design/atoms/drop-down/drop-down.component';
import { FuseCardModule } from '../../@fuse/components/card';
import { AllDesignComponent } from './generic-design/all-design/all-design.component';
import { ControlDesignComponent } from './generic-design/control-design/control-design.component';

import { MatSliderModule } from '@angular/material/slider';
import { IcornButtonRenderComponent } from './icorn-button-render/icorn-button-render.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { MtxDatetimepickerModule } from '@ng-matero/extensions/datetimepicker';
import { MatListModule, MatSelectionList } from '@angular/material/list';
import { ThousandSuffixesPipe } from './thousand-suffixes.pipe';
import { RouterModule } from '@angular/router';
import { ColorInputFormat, MAT_COLOR_FORMATS, NgxMatColorPickerModule, NGX_MAT_COLOR_FORMATS } from '@angular-material-components/color-picker';
import { SeatsioAngularModule } from '@seatsio/seatsio-angular';

import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DropDownRendererComponent } from './drop-down-renderer/drop-down-renderer.component';
import { ColorPickerModule } from '@iplab/ngx-color-picker';
import { UploadExcelComponent } from "./upload-excel/upload-excel.component";
import { ShowRendererComponent } from './show-renderer/show-renderer.component'
import { SafeHtmlPipe } from '../../@shelter/safe-html.pipe';
import { ServerImagePipe } from '../../@shelter/server-image.pipe';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { ViewRenderComponent } from './view-render/view-render.component';
import { PrintTicketRenderComponent } from './print-ticket-render/print-ticket-render.component';
import { LocalizationRenderComponent } from './localization-render/localization-render.component';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzSelectModule } from 'ng-zorro-antd/select';

export const MatColorFormats = {
    display: {
        colorInput: 'hex'
    }
};

const materialModules = [
    MatIconModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    MatButtonModule,
    MatChipsModule,
    MatMenuModule,
    MatDialogModule,
    MatTableModule,
    MatDividerModule,
    MatTableModule,
    MatTabsModule,
    MatRadioModule,
    MatMomentDateModule,
    MatStepperModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatCardModule,
    MatAutocompleteModule,
    MatBottomSheetModule,
    MatSlideToggleModule,
    QuillModule,
    MatExpansionModule,
    CdkAccordionModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatSidenavModule,
    MatProgressBarModule,
    FuseCardModule,
    MatSliderModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MtxDatetimepickerModule,
    MatListModule,
    // MatSelectionList,
    MatButtonToggleModule,
    NgxMatColorPickerModule,
    NgxMaterialTimepickerModule,
    ColorPickerModule,
    NzDatePickerModule

];
@NgModule({
    declarations: [
        CheckboxRendererComponent,
        DeleteModalComponent,
        DeleteRendererComponent,
        EditRendererComponent,
        ControlGenericComponent,
        TextComponent,
        DateComponent,
        NumberComponent,
        LocationPickerComponent,
        ImagePickerComponent,
        DropDownEntityComponent,
        LocalizedPipe,
        CheckboxComponent,
        IconRendererComponent,
        DropDownComponent,
        AllDesignComponent,
        ControlDesignComponent,
        IcornButtonRenderComponent,
        ThousandSuffixesPipe,
        DropDownRendererComponent,
        UploadExcelComponent,
        ShowRendererComponent,
        SafeHtmlPipe,ServerImagePipe, ViewRenderComponent, PrintTicketRenderComponent, LocalizationRenderComponent

    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ...materialModules,
        TranslocoModule,
        AgmCoreModule,
        AgGridModule,
        SeatsioAngularModule,
        NzPaginationModule,
        NzSelectModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ...materialModules,
        TranslocoModule,
        AgGridModule,
        CheckboxRendererComponent,
        DeleteModalComponent,
        DeleteRendererComponent,
        EditRendererComponent,
        ControlGenericComponent,
        TextComponent,
        DateComponent,
        NumberComponent,
        LocationPickerComponent,
        ImagePickerComponent,
        DropDownEntityComponent,
        LocalizedPipe,
        CheckboxComponent,
        IconRendererComponent,
        DropDownComponent,
        AllDesignComponent,
        ControlDesignComponent,
        IcornButtonRenderComponent,
        ThousandSuffixesPipe,
        SeatsioAngularModule,
        UploadExcelComponent,
        SafeHtmlPipe,ServerImagePipe,
        NzPaginationModule,
        NzSelectModule
    ],
    providers:[
        { provide: MAT_COLOR_FORMATS, useValue: MatColorFormats },
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
        


    ]
})
export class SharedModule {
}
